/** KAN-754: пометка ручного товара или категории (не из фида). */
import { Badge } from '@/components/ui/badge';

export function ManualBadge({ label = 'Добавлен вручную' }: { label?: string }) {
  return (
    <Badge variant="processing" className="whitespace-nowrap font-normal">
      {label}
    </Badge>
  );
}
